import { FUND_INVESTMENTS_TITLE_SINGULAR } from 'pages/FundInvestments/common/constants';

export const BULK_ACTIONS = 'Bulk Actions';
export const EDIT_COMPANY = 'Edit Company';
export const EDIT_COMMON_PROFILE = 'Edit Common Profile';
export const EDIT_FUND_INVESTMENT = `Edit ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const EXCEL_EXPORT = 'Excel Export';
export const PDF_EXPORT = 'PDF Export';
export const SAVE = 'Save';
